import { render, staticRenderFns } from "./SupplierOnboardingLayout.vue?vue&type=template&id=792978f5&"
import script from "./SupplierOnboardingLayout.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingLayout.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOnboardingLayout.vue?vue&type=style&index=0&id=792978f5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports